/**
 * @file index.tsx
 *
 * @fileoverview Renders a product box from a ProductParagraph type.
 */
import React from 'react';
import Price from '~/jobiqo/models/price';
import { ProductParagraph } from '~/jobiqo/types/types';
import { ProductBox } from '~/vcl/organisms/10-commerce/01-product-box';
import { FormattedMessage } from 'react-intl';
import Link from '~/jobiqo/components/Link';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import NextLink from 'next/link';

interface ProductReferenceBoxProps {
  /**
   * The product to display.
   */
  product: ProductParagraph;
}

export default function ProductReferenceBox({
  product,
}: ProductReferenceBoxProps) {
  const productPrice = new Price(
    product.product?.priceNumber as string,
    product.product?.priceCurrency,
  );

  return (
    <ProductBox
      title={product.product?.name ?? ''}
      intro={''}
      price={
        product.product?.priceUrl ? null : productPrice.getPriceRepresentation()
      }
      button={
        product.product?.priceUrl ? (
          <Link href={product.product?.priceUrl} prefetch={false} asChild>
            <LinkButton buttonStyle="primary">
              <FormattedMessage
                id="product_grid_item_buy_contact"
                defaultMessage="Contact"
              />
            </LinkButton>
          </Link>
        ) : (
          <Link
            href={`/checkout/${product.product?.id}`}
            prefetch={false}
            asChild
          >
            <LinkButton buttonStyle="primary" linkElement={NextLink}>
              <FormattedMessage
                id="product_grid_item_buy"
                defaultMessage="Buy now"
              />
            </LinkButton>
          </Link>
        )
      }
      content={
        <WYSIWYGText
          format="filtered_html"
          content={product.product?.description ?? ''}
        />
      }
    />
  );
}
